import { render, staticRenderFns } from "./MilestoneCard.vue?vue&type=template&id=3901818a"
import script from "./MilestoneCard.vue?vue&type=script&lang=js"
export * from "./MilestoneCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports